import { createFeatureSelector } from "@ngrx/store";
import { ApiClientState } from "../models/api-client-state";
import { StoreKeys } from "../store-keys";

export class ApiAccessSelectors {
	static readonly apiClients = createFeatureSelector<ApiClientState>(
		StoreKeys.apiAccessStateKey
	);
}
